export function DeleteIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className="h-5 w-4 text-white"
      viewBox="0 0 16 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.776 14.83a.493.493 0 01-.341-.117.453.453 0 01-.137-.328L5.093 7.22a.402.402 0 01.123-.322c.086-.086.2-.13.342-.13.14 0 .255.042.341.124a.42.42 0 01.13.32l.212 7.165a.431.431 0 01-.465.451zm2.01 0a.502.502 0 01-.348-.124.423.423 0 01-.13-.321V7.22c0-.132.043-.24.13-.322a.486.486 0 01.348-.13c.146 0 .262.044.349.13.09.082.136.19.136.322v7.164a.411.411 0 01-.136.321.486.486 0 01-.349.123zm2.017 0a.486.486 0 01-.349-.124.423.423 0 01-.116-.328l.205-7.157a.453.453 0 01.137-.328.467.467 0 01.335-.123c.146 0 .26.043.341.13a.397.397 0 01.123.32l-.205 7.165a.452.452 0 01-.136.328.483.483 0 01-.335.116zm-5.12-9.968V3.386c0-.524.157-.932.471-1.224.32-.296.761-.444 1.326-.444h2.598c.565 0 1.007.148 1.326.444.32.292.479.7.479 1.224v1.476H9.618V3.447a.54.54 0 00-.17-.417.634.634 0 00-.459-.164H6.57a.624.624 0 00-.45.164.54.54 0 00-.172.417v1.415H4.683zm-3.029.752a.587.587 0 01-.43-.177.587.587 0 01-.178-.431c0-.164.06-.303.178-.417a.587.587 0 01.43-.178h12.27c.17 0 .31.057.425.171a.564.564 0 01.177.424.586.586 0 01-.177.43.564.564 0 01-.424.178H1.655zm2.994 11.532c-.528 0-.952-.148-1.271-.444-.314-.296-.483-.709-.506-1.237l-.478-9.98h1.25l.472 9.768c.01.2.075.364.198.492.124.128.28.192.472.192h6.002a.627.627 0 00.472-.192.713.713 0 00.198-.492l.451-9.769h1.272l-.472 9.974c-.023.529-.194.941-.513 1.237-.319.301-.74.451-1.264.451H4.648z"
        fill="currentColor"
      />
    </svg>
  );
}

export function MoreIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className="h-[3px] w-[13px] text-white"
      viewBox="0 0 13 3"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.58 1.5h.008-.009zm5.833 0h.008-.008zm4.833 0h.008-.008zm-9.833 0a.833.833 0 11-1.667 0 .833.833 0 011.667 0zm5 0a.833.833 0 11-1.667 0 .833.833 0 011.667 0zm4.833 0a.833.833 0 11-1.667 0 .833.833 0 011.667 0z"
        fill="currentColor"
      />
      <path
        d="M1.58 1.5h.008m5.825 0h.008m-.008 0a.833.833 0 11-1.667 0 .833.833 0 011.667 0zm4.833 0h.008m-.008 0a.833.833 0 11-1.667 0 .833.833 0 011.667 0zm-9.833 0a.833.833 0 11-1.667 0 .833.833 0 011.667 0z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
      />
    </svg>
  );
}

export function SyncIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className="h-[21px] w-6 text-white"
      viewBox="0 0 24 21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.677 10.523L3.66 7.734c.155-.21.332-.312.53-.307.206 0 .383.103.532.307L6.7 10.532c.188.249.24.473.157.672-.083.2-.282.299-.597.299H5.014c.11.83.362 1.602.755 2.316.398.714.9 1.339 1.502 1.876a6.69 6.69 0 002.076 1.245 6.805 6.805 0 002.473.448c.996 0 1.926-.196 2.79-.59a6.702 6.702 0 002.224-1.601c.2-.194.41-.293.63-.3a.776.776 0 01.59.217c.166.15.25.343.25.58.005.233-.092.45-.291.648a8.472 8.472 0 01-2.756 1.992 8.031 8.031 0 01-3.437.747 8.344 8.344 0 01-3.112-.58 8.584 8.584 0 01-2.615-1.628 8.708 8.708 0 01-1.885-2.415 8.287 8.287 0 01-.913-2.955H2.117c-.321 0-.52-.1-.598-.299-.077-.2-.025-.426.158-.68zm3.95-5.852A8.663 8.663 0 018.376 2.68a8.086 8.086 0 013.445-.747c1.09 0 2.123.197 3.096.59a8.58 8.58 0 012.624 1.626 8.708 8.708 0 011.884 2.416 8.41 8.41 0 01.921 2.955H21.5c.321 0 .52.1.598.299.083.2.033.426-.15.68l-1.975 2.79c-.155.21-.335.315-.54.315-.2-.005-.373-.11-.523-.315l-1.984-2.79c-.182-.254-.235-.48-.157-.68.083-.2.282-.299.597-.299h1.262c-.122-.83-.38-1.6-.772-2.308a6.816 6.816 0 00-1.494-1.876 6.715 6.715 0 00-2.067-1.253 6.703 6.703 0 00-2.474-.457c-.99 0-1.92.2-2.789.598a6.875 6.875 0 00-2.224 1.594c-.2.194-.413.293-.64.299a.794.794 0 01-.58-.224.75.75 0 01-.266-.573c0-.233.102-.448.307-.648z"
        fill="currentColor"
      />
    </svg>
  );
}
